var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconIdCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.98008 12.824C7.98008 11.2826 9.23871 10.024 10.7801 10.024C12.3214 10.024 13.5801 11.2826 13.5801 12.824C13.5801 14.3654 12.3214 15.624 10.7801 15.624C9.23871 15.624 7.98008 14.3654 7.98008 12.824ZM10.7801 11.224C9.90145 11.224 9.18008 11.9454 9.18008 12.824C9.18008 13.7026 9.90145 14.424 10.7801 14.424C11.6587 14.424 12.3801 13.7026 12.3801 12.824C12.3801 11.9454 11.6587 11.224 10.7801 11.224Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7596 16.424H10.8005L10.8082 16.4242C13.1855 16.4852 14.4734 17.326 15.0773 17.9053L15.0815 17.9094L15.0857 17.9135C15.4115 18.2387 15.5801 18.7274 15.5801 19.2145V21.024C15.5801 21.3554 15.3114 21.624 14.9801 21.624H6.58008C6.24871 21.624 5.98008 21.3554 5.98008 21.024V19.2145C5.98008 18.7457 6.12612 18.239 6.48839 17.9001C7.1004 17.3276 8.38469 16.4853 10.7519 16.4242L10.7596 16.424ZM10.7752 17.624C8.71844 17.6788 7.7138 18.397 7.30813 18.7765C7.26313 18.8186 7.18008 18.9595 7.18008 19.2145V20.424H14.3801V19.2145C14.3801 18.9817 14.297 18.8243 14.241 18.766C13.8487 18.3919 12.8474 17.6786 10.785 17.624H10.7752Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1801 10.224H18.1801V11.424H26.1801V10.224Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1801 13.424H26.1801V14.624H18.1801V13.424Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1801 16.624H18.1801V17.824H26.1801V16.624Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1801 19.824H22.1801V21.024H18.1801V19.824Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.58008 8.544C2.58008 7.2627 3.61878 6.224 4.90008 6.224H27.1001C28.3814 6.224 29.4201 7.2627 29.4201 8.544V23.704C29.4201 24.9853 28.3814 26.024 27.1001 26.024H4.90008C3.61878 26.024 2.58008 24.9853 2.58008 23.704V8.544ZM4.90008 7.424H27.1001C27.7186 7.424 28.2201 7.92544 28.2201 8.544V23.704C28.2201 24.3226 27.7186 24.824 27.1001 24.824H4.90008C4.28152 24.824 3.78008 24.3226 3.78008 23.704V8.544C3.78008 7.92544 4.28152 7.424 4.90008 7.424Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIdCard);
export default __webpack_public_path__ + "static/media/Icon-id_card.6afbf2872e4ae994b9ceb1728483f870.svg";
export { ForwardRef as ReactComponent };